import { combineReducers } from "redux";
import userReducer from "./user.reducer";
import annonceReducer from "./annonce.reducer";

export default combineReducers({
    userReducer,
    annonceReducer
})